/*
 *
 */

var utils = {
  changeLanguage: (e) => {
    i18next.changeLanguage(e.item.lang);
    riot.update();
  },
  getCurrencyText: (currency, isPlural) => {
    return {
      "JPY": "えん",
      "USD": isPlural ? "Dollars" : "Dollar",
      "EUR": isPlural ? "Euros" : "Euro",
      "GBP": isPlural ? "Pounds" : "Pound",
      "NTD": "台湾元",
    }[currency];
  },
};

export default utils;

